import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30a37327")

_pushScopeId("data-v-30a37327")
const _hoisted_1 = { class: "parameter-card" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "p-grid p-ai-center" }
const _hoisted_4 = { class: "p-m-0  p-col-12 p-md-12 p-lg-4 p-xl-4" }
const _hoisted_5 = { class: "kn-material-input-label" }
const _hoisted_6 = {
  key: 0,
  class: "p-m-0 p-col-12 p-md-12 p-lg-4 p-xl-4"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "kn-material-input-label" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "kn-material-input-label" }
const _hoisted_11 = {
  key: 1,
  class: "p-m-0 p-col-12 p-md-12 p-lg-4 p-xl-4"
}
const _hoisted_12 = { class: "kn-material-input-label" }
const _hoisted_13 = {
  key: 2,
  class: "p-m-0  p-col-12 p-md-12 p-lg-4 p-xl-4"
}
const _hoisted_14 = { class: "kn-material-input-label" }
const _hoisted_15 = { class: "p-m-0  p-col-12 p-md-12 p-lg-4 p-xl-4" }
const _hoisted_16 = { class: "kn-material-input-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_MultiSelect = _resolveComponent("MultiSelect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.parameter && !_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("h2", null, _toDisplayString(_ctx.parameter.name), 1),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", null, [
                _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.scheduler.parameterValueType')), 1),
                _createVNode(_component_Dropdown, {
                  class: "kn-material-input",
                  modelValue: _ctx.parameter.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.parameter.type = $event)),
                  options: _ctx.parameter.temporal ? _ctx.triggerStrategies : _ctx.triggerStrategies.slice(0, 2),
                  optionLabel: "label",
                  optionValue: "value",
                  onChange: _ctx.onParameterTypeChange
                }, null, 8, ["modelValue", "options", "onChange"])
              ])
            ]),
            (_ctx.parameter.type === 'fixed')
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  (_ctx.parameterValues.manualInput)
                    ? (_openBlock(), _createBlock("span", _hoisted_7, [
                        _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('common.values')), 1),
                        _createVNode(_component_InputText, {
                          class: "kn-material-input",
                          modelValue: _ctx.parameter.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.parameter.value = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : (_openBlock(), _createBlock("span", _hoisted_9, [
                        _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.values')), 1),
                        _createVNode(_component_MultiSelect, {
                          class: "kn-material-input",
                          modelValue: _ctx.parameter.selectedValues,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.parameter.selectedValues = $event)),
                          options: _ctx.parameterValues.values,
                          onChange: _ctx.formatSelectedValues
                        }, null, 8, ["modelValue", "options", "onChange"])
                      ]))
                ]))
              : (_ctx.parameter.type === 'loadAtRuntime')
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode("span", null, [
                      _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('common.role')), 1),
                      _createVNode(_component_Dropdown, {
                        class: "kn-material-input",
                        modelValue: _ctx.parameter.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.parameter.value = $event)),
                        options: _ctx.rolesOptions,
                        optionLabel: "role",
                        optionValue: "userAndRole"
                      }, null, 8, ["modelValue", "options"])
                    ])
                  ]))
                : (_ctx.parameter.type === 'formula')
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("span", null, [
                        _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('managers.scheduler.selectFormula')), 1),
                        _createVNode(_component_Dropdown, {
                          class: "kn-material-input",
                          modelValue: _ctx.parameter.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.parameter.value = $event)),
                          options: _ctx.formulaOptions,
                          optionLabel: "description",
                          optionValue: "name"
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
            _createVNode("div", _hoisted_15, [
              _createVNode("span", null, [
                _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('managers.scheduler.iterations')), 1),
                _createVNode(_component_Dropdown, {
                  class: "kn-material-input",
                  modelValue: _ctx.parameter.iterative,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.parameter.iterative = $event)),
                  options: _ctx.triggerIterations,
                  optionLabel: "label",
                  optionValue: "value"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})